<hb-modal-dialog
  [heading]="config?.title"
  [okDisabled]="selectedItems.length === 0"
  (okClicked)="submitClick()">
  <div content>
    <div style="max-height: 500px; overflow-y: scroll">
      <hb-table
        *ngIf='config'
        [id]="tableConfig.id"
        [data]="data.availableItems"
        [config]="tableConfig"
        [selectedItems]="selectedItems"
        (selectionChange)="onSelectionChange($event)">
      </hb-table>
    </div>
  </div>
</hb-modal-dialog>
